// Type Imports
import { EnhancedThreshold, Threshold } from '../interface';

/* ===== Function =====
@DESC: thresholdFormatter returns a formatted array of thresholds,
concatenating bands with the same name and adding a max value that sits up
against the next band in the range.
@ARGS: threshold array(derived from API getOverlays call)
*/
const theresholdFormatter = (thArr: Threshold[], activeOverlay: string) => {
  const newThArr: EnhancedThreshold[] = [];
  thArr.forEach((th, idx, arr) => {
    const newTH = { ...th, max: null };
    newThArr.push(newTH);

    // if not last, set max to next min
    if (idx !== arr.length - 1) {
      newThArr[newThArr.length -1].max = arr[idx + 1].min;
    }
  });
  return newThArr;
};

export default theresholdFormatter;
